import { ReactComponent as SalesIcon } from "../../../assets/images/sales_report.svg";

export const ICON_SIZE = 25;
export const X_REPORT_HREF = "x_report";
export const Z_REPORT_HREF = "z_report";
export const REPORT_LIST = [
    {
        label: "X Report",
        href: `/${X_REPORT_HREF}`,
        icon: <SalesIcon width={ICON_SIZE} height={ICON_SIZE} />,
    },
    {
        label: "Z Report",
        href: `/${Z_REPORT_HREF}`,
        icon: <SalesIcon width={ICON_SIZE} height={ICON_SIZE} />,
    },
];